import React from 'react';
import axios from 'axios';
import {debounce} from 'throttle-debounce';

import AutocompleteResult from './AutocompleteResult';


export default class BusinessSearchAutocomplete extends React.Component {

    constructor(props) {
        super();
        this.state = {
            results: [],
            searchFocused: false
        };
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.getSuggestions = this.getSuggestions.bind(this);
    }

    /**
     * Query the Anvil endpoint for suggestions related to a search value.
     *
     * @param search_value - The term to show suggestions for.
     * @param number_of_results - The number of suggestions to request from Anvil.
     * @returns {AxiosPromise}
     */
    getSuggestions(search_value, number_of_results) {
        return axios.post(this.props.autocompleteUrl, {
            directory: this.props.directoryId,
            search_term: search_value,
            number_of_results: number_of_results
        });
    }

    componentWillMount() {
        // Create a debounced autocomplete function to prevent spamming our endpoint with API calls.
        this.delayedSearch = debounce(200, (search_value, number_of_results=5) => {
            this.getSuggestions(search_value, number_of_results).then((response) => {
                this.setState((state, props) => {
                    // Prevent results from being displayed after the search value has been cleared by the user.
                    if (state.search_value !== "")
                        return {results: response.data};
                });
            });
        });
    }

    componentDidMount() {
        let usedIndexes = [];
        let getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));
        // When the component loads, get the top 3 suggestions from anvil to use as placeholder text.
        this.getSuggestions("", 10).then((response) => {
            let placeholder = "";
            while (usedIndexes.length < Math.min(3, response.data.length)) {
                let index = getRandomInt(response.data.length);
                if (!usedIndexes.includes(index)) {
                    let suggestion = response.data[index];
                    if (placeholder !== "") {
                        placeholder += ", ";
                    }
                    placeholder += suggestion.name.toLowerCase();
                    usedIndexes.push(index);
                }
            }
            placeholder += "...";
            this.setState({
                placeholder: placeholder
            });
        });
    }

    handleKeyPress(event) {
        let search_value = event.target.value.trim();
        this.setState({search_value: search_value});
        if (search_value) {
            this.delayedSearch(search_value);
        } else {
            this.setState({
                results: []
            });
        }
    }

    render() {
        let showSearchSuggestions = this.state.searchFocused && this.state.results.length > 0;
        let searchContainerClasses = ["column", "search__container"];
        let searchSuggestionsClasses = ["column", "search__suggestions"];
        if (showSearchSuggestions) {
            searchContainerClasses.push("search__container--results-active");
            searchSuggestionsClasses.push("search__suggestions--active");
        }
        return (
            <form action={this.props.searchUrl} method={this.props.searchMethod || "get"}>
                <div className={`search search--${this.props.sassPrefix}`}>
                    <div className={searchContainerClasses.join(' ')}>
                        <div className="row expanded search__bar">
                                <div className="column small-1 shrink search__label">Search</div>
                                <div className="column">
                                    <input className="search__input"
                                           type="text"
                                           autoComplete="off"
                                           name={this.props.searchName || "q"}
                                           onKeyUp={this.handleKeyPress}
                                           onFocus={()=>this.setState({searchFocused: true})}
                                           onBlur={()=>setTimeout(()=>this.setState({searchFocused: false}), 200)}
                                           placeholder={this.state.placeholder}
                                           defaultValue={this.props.searchValue}/>
                                </div>
                                <button className="column small-1 shrink search__button" />
                        </div>
                    </div>
                    <div className={searchSuggestionsClasses.join(' ')}>
                        {this.state.results.map(
                            (item, index) => {
                                let logoClassName = "";
                                if (item.type === "business") {
                                    logoClassName = "store-icon";
                                } else if (item.type === "category") {
                                    logoClassName = "tag-icon";
                                }
                                return <AutocompleteResult
                                            key={index}
                                            href={item.url}
                                            name={item.name}
                                            logoClass={logoClassName}
                                            sassPrefix={this.props.sassPrefix}/>;
                            }
                        )}
                    </div>
                </div>
            </form>
        );
    }

}